var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 60,
    height: 60,
    style: {},
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.064 19.168c-1.856 0-3.52 0.928-4.48 2.368l-6.848-3.808c0.384-0.736 0.608-1.6 0.608-2.496s-0.224-1.728-0.608-2.464l5.216-2.272c0.992 1.408 2.624 2.336 4.448 2.336 3.008 0 5.44-2.432 5.44-5.408s-2.432-5.44-5.44-5.44-5.408 2.432-5.408 5.44c0 0.608 0.096 1.184 0.288 1.76l-5.408 2.336c-0.992-1.056-2.4-1.728-3.936-1.728-0.002 0-0.003 0-0.005 0-3.002 0-5.435 2.433-5.435 5.435 0 0.002 0 0.004 0 0.005v-0c0 2.976 2.432 5.408 5.44 5.408 1.536 0 2.912-0.64 3.904-1.696l7.072 3.936c-0.162 0.506-0.256 1.087-0.256 1.691 0 0.002 0 0.004 0 0.006v-0c0 3.008 2.432 5.408 5.408 5.408s5.408-2.432 5.408-5.408-2.4-5.408-5.408-5.408z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.c1a6edaebf9d7d4f9581aa4c7e5f51d5.svg";
export { ForwardRef as ReactComponent };